import {Injectable,EventEmitter, Output} from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import {LogserviceService} from '../logservice/logservice.service';
import {SectionBuilderService} from '../sectionbuilder-services/sectionbuilder';
import {Element} from '../../model/Element';
import {ElementType} from '../../model/element-type.enum';
import {GenericField} from '../../model/GenericFields';
import {Entity} from "../../model/entity";
import { Datatype } from '../../model/datatype.enum';
import * as jq from 'jquery';
import { Context } from '../../model/context';
import { HttpHeaders,HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { retry, catchError } from 'rxjs/operators';
import * as moment from 'moment';
import { LocalStorageService } from 'src/app/services/localstorage-service/localstorage-service';
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/json',
        //'Access-Control-Allow-Origin': '*',
        'Cache-Control': 'private, max-age=1200',        
    })
  };
@Injectable({ providedIn: 'root' })

export class StandardUIService {
public editorOptions: Object = { key: 'sZH1rB3A5B6D5G4E4iAa1Tb1YZNYAh1CUKUEQOHFVANUqD1G1F4A3B1C8E7D2C4F3==' };

constructor(private localStorageService : LocalStorageService,private logService:LogserviceService,private sectionBuilderService:SectionBuilderService,private httpClient:HttpClient) { }
objectData:any;
objectMetaData:any;
httpHeaders = new HttpHeaders();
backendUrl = environment.apiURL;
@Output() change: EventEmitter<object> = new EventEmitter();
private incident = new BehaviorSubject<object>(null);
castIncident = this.incident.asObservable();
private userDetails = new BehaviorSubject<any>(null);
castuserDetails = this.userDetails.asObservable();
getAllStandardUIControls()
{
    this.logService.logMessage('call standard ui elements','debug');
    //return this.draggable_elements ;
  }
  randomId(){
    return Math.floor(Math.random()*(999-100+1)+100)+Date.now();
}

saveAgentRecentAccess(payload:any)
{
   // console.log(payload)
    return this.httpClient.post(this.backendUrl+ 'saveAgentRecents',payload);
}
//Rendering html

renderHtml(rows,sectionData,context:Context) {
    //// console.log(rows);
    //// console.log(sectionData);
    //return false;
    var div = "";
    let style = "";

    if(rows){
        //console.log(rows);
        if(sectionData.bgimage) {
            //  style += "background-image:url("+sectionData.bgimage+");";
            //  style += "background-repeat:no-repeat;";
            //  style += "background-size:100% 100%;";
         }
         div += '<div class="formbuilder-page" style="'+style+'" data-elementid="'+sectionData.id+'">';

         for(var row =0;row<rows.length;row++) {
             var cols = rows[row].cols;
             let rowstyle = "";
             if(rows[row].bgcolor) {
                rowstyle += "background:"+rows[row].bgcolor+";";
             }
             if(rows[row].border) {
                rowstyle += "border:"+rows[row].border+";";
             }
             div += '<div style="'+rowstyle+'" class="row '+rows[row].border+'" data-elementid="'+rows[row].id+'">';
             for(var col = 0;col<cols.length;col++){
                 //var colclass = this.getClass(cols.length);
                 let colclass = "";
                 let colstyle = "";
                 let wrapElement = "";
                 if(cols[col].border){colstyle += "border:"+cols[col].border+";";}
                 if(cols[col].bgcolor){colstyle += "background:"+cols[col].bgcolor+";";}
                 if(cols[col].colwidth){colclass =  cols[col].colwidth;}
                 if(cols[col].wrapElement){wrapElement =  cols[col].wrapElement;}
                 div += '<div style="'+colstyle+'" class="col '+colclass+' '+wrapElement+'">';
                 for(var ele=0;ele<cols[col].data.length;ele++){
                     var obj = cols[col].data[ele];
                     if(obj.elementType == ElementType.GENERICFIELD){
                         //console.log(obj);
                         div +=  this.getGenericHtml(obj,context);
                     }else{
                         div +=  this.getUIHTML(obj,context);
                     }
                 }
                 div += '</div>';
             }
             div += '</div>';
         }

         div += '</div>';

     }
    return div;
}
settings:any;
// tableData:LocalDataSource;
tabIds = [];
getGenericHtml(data,context:Context){
    //console.log(data);
    var output = "";
    //var requiredClass = "{'required':"+((data.is_required) ? true : false)+"}";
    let requiredClass = [];
    (data.is_required) ? requiredClass.push('required ') : '';
    var css = ['floating-label'];
    var inlineCss = [];
    var style = [];
    var fieldwidth = [];
    let labelClass = '';
    let fieldClass = '';
    let labelHtml = '';
    (data.bold == "Yes") ? css.push('font-weight-bold') : '';
    (data.fontStyle == "italic") ? css.push('italic') : (data.fontStyle == "underline") ? css.push('underline') : (data.fontStyle == "italic_underline") ? css.push('italic_underline') : '';
    (data.cssClass) ? css.push(data.cssClass) : '';
    //(data.inline) ? inlineCss.push('form-inline') : '';
    if(data.inline){
        inlineCss.push('form-inline');
        labelClass = 'col-md-3sss';
        if(data.isTextHide){
            fieldClass = 'col-md-12 floating-input';
        }else{
            fieldClass = 'col-md-9sss floating-input';
        }
    }else{
        labelClass = '';
        fieldClass = 'floating-input';
        //inlineCss.push('')
    }
    //(data.textAlign) ? css.push(data.textAlign) : '';
    (data.fontColor) ? style.push("color:"+data.fontColor+";") : '';
    (data.fontSize) ? style.push("font-size:"+data.fontSize+"px;") : '';
    (data.fieldWidth) ? fieldwidth.push("width:"+data.fieldWidth+"%;") : '';
    if(data.isTextHide == false){
        if(data.is_required){
            labelHtml = '<span class="highlight"></span><label data-toggle="tooltip" title="'+data.label+'" style="'+style.join("")+'" class="required '+data.textAlign+' '+labelClass+'">'+data.label+'<span>*</span></label>';
        }else{
            labelHtml = '<span class="highlight"></span><label data-toggle="tooltip" title="'+data.label+'" style="'+style.join("")+'" class="'+data.textAlign+' '+labelClass+'">'+data.label+'</label>';
        }
    }else{
        labelHtml = '';
    }
    switch(data.genericField.dataType)
    {
        case Datatype.TEXT:
            let textType = (data.genericField.formatType) ? data.genericField.formatType : "";                       
            this.checkEditable(data,css.join(" "));
            output += '<div class="smart-controls autocwidth format-text form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output +='<label [hidden]="'+data.isTextHide+'" style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+requiredClass.join(" ")+labelClass+'" [ngClass]="'+requiredClass+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
            // if(data.labelAlign == 'Right'){
            //     output += '<input [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'"  style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="text" data-texttype="'+textType+'" id="'+data.id+'" name="'+data.genericField.name+'" />';
            //     output += labelHtml;
            // }else{
            //    output += labelHtml;
            //    output += '<input [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'"  style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="text" data-texttype="'+textType+'" id="'+data.id+'" name="'+data.genericField.name+'" />';
            // }
            if(data.labelAlign == 'Right'){
                if(data.isTextArea){
                    output += '<textarea rows="5" [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'"  style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" name="'+data.genericField.name+'"></textarea>';
                }else{
                    output += '<input title="'+data.label+'" [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'"  style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="text" data-texttype="'+textType+'" name="'+data.genericField.name+'" />';
                }
                output += labelHtml;
            }else{

               if(data.isTextArea){

                    //output += '<textarea [froalaEditor]=\''+JSON.stringify(this.editorOptions)+'\' rows="6" [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'"  style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" name="'+data.genericField.name+'"></textarea>';
                    output += '<textarea rows="6" [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'"  style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" name="'+data.genericField.name+'"></textarea>';
                }else{
                    output += '<input title="'+data.label+'" [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'"  style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="text" data-texttype="'+textType+'" name="'+data.genericField.name+'" />';
                }
                output += labelHtml;
            }
            output += '</div>';
            break;
        case Datatype.NUMBER:
            output += '<div class="smart-controls autocwidth format-number form-group '+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label [hidden]="'+data.isTextHide+'" style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+labelClass+'" [ngClass]="'+requiredClass+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';

            output += '<input title="'+data.label+'"  [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="number" name="'+data.genericField.name+'"/>';
            output += labelHtml;
            output += '</div>';
            break;
        case Datatype.DECIMAL:
            output += '<div class="smart-controls autocwidth format-number form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label [hidden]="'+data.isTextHide+'" style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+labelClass+'" [ngClass]="'+requiredClass+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';

            output += '<input title="'+data.label+'" [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="number" name="'+data.genericField.name+'"/></div>';
            output += labelHtml;
            break;
        case Datatype.MENU:
            //console.log(data.repeatedList);
            //this.SortByName(x,y)
            //if(data.repeatedList)
            //console.log(data.repeatedList);
            
            if(data.is_read_only){
                fieldClass = "floating-input";
            }else{
                fieldClass = "floating-input";
            }
            if(data.repeatedList){
                data.repeatedList.sort(this.SortByName);
            }
            this.checkEditable(data,css.join(" "));
            // let role1 = JSON.parse(this.localStorageService.get('currentUser'));
            //// console.log(role.roles[0].authority.split(" ").join("-"));
            // let role_editable1 = role?.roles[0]?.authority?.split(" ")?.join("") + '_editable';
            // if(role_editable){
            //     let editableText = this.findTextInSentence(css.join(" "),role_editable);
            //    // console.log(role_editable,editableText);
            //     if(editableText) data.is_read_only = false;
            // }  
            output += '<div class="smart-controls autocwidth format-menu form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';


            if(data.multiselect_option == true)
            {
                //console.log("Multi",data);
                // output += '<ejs-multiselect class="form-control '+fieldClass+'" [htmlAttributes]="{name:\''+data.genericField.name+'\'}" [dataSource]= \''+JSON.stringify(data.repeatedList)+'\'';
                // output += '[fields]="checkFields" [mode]="mode" [popupHeight]="popHeight" [showDropDownIcon]="true" [placeholder]="checkWaterMark"';
                // output += 'showSelectAll="true" [filterBarPlaceholder]="filterPlaceholder">';
                // output += '</ejs-multiselect>';
                output += '<select data-width="'+((data.fieldWidth) ? data.fieldWidth+'%' : '60%')+'" title="'+data.label+'" multiple [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'" style="'+fieldwidth.join("")+'" class="floating-select multichosen form-control " name="'+data.genericField.name+'"><option value=""></option>';
                if(data.repeatedList){
                    for(var i = 0;i<data.repeatedList.length;i++){
                        output += '<option value="'+data.repeatedList[i].option_value+'">'+data.repeatedList[i].option_label+'</option>';
                    }
                }
                output += '</select>';
            }else{
                //output += '<label [hidden]="'+data.isTextHide+'" style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+labelClass+'" [ngClass]="'+requiredClass+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
                output += '<select (click)="$event.target.setAttribute(\'value\', $event.target.value);" data-width="'+((data.fieldWidth) ? data.fieldWidth+'%' : '60%')+'" title="'+data.label+'"  [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'" style="'+fieldwidth.join("")+'" class="form-select picklist '+fieldClass+'" name="'+data.genericField.name+'"><option value=""></option>';
                if(data.repeatedList){
                    for(var i = 0;i<data.repeatedList.length;i++){
                        output += '<option value="'+data.repeatedList[i].option_value+'">'+data.repeatedList[i].option_label+'</option>';
                    }
                }
                output += '</select>';

            }
            output += labelHtml;
            output += '</div>';
            break;
        case Datatype.DATE:
            output += '<div class="smart-controls autocwidth format-date form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label [hidden]="'+data.isTextHide+'" style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+labelClass+'" [ngClass]="'+requiredClass+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';

            if(data.genericField.columnName == "updatedtime" || data.genericField.columnName == "createdtime"){
                output += '<input title="'+data.label+'"  readonly data-date-format="MM/DD/YYYY" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="'+((data.is_read_only) && (context) ? 'date' : 'date')+'" (click)="($event.target.type=\'date\')" (focusout)="($event.target.type=\'date\')" name="'+data.genericField.name+'"/>';
            }else{
                output += '<input title="'+data.label+'"  [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'" data-date-format="MM/DD/YYYY" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="'+((data.is_read_only) && (context) ? 'date' : 'date')+'" (click)="($event.target.type=\'date\')" (focusout)="($event.target.type=\'date\')" name="'+data.genericField.name+'"/>';
            }
            output += labelHtml;
            output += '</div>';
            break;
        case Datatype.DATETIME:

            output += '<div class="smart-controls autocwidth format-datetime form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label [hidden]="'+data.isTextHide+'" style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+labelClass+'" [ngClass]="'+requiredClass+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';

            if(data.genericField.columnName == "updatedtime" || data.genericField.columnName == "createdtime"){
                output += '<input title="'+data.label+'"  readonly data-date-format="MM/DD/YYYY" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="'+((data.is_read_only) && (context) ? 'datetime-local' : 'datetime-local')+'" (click)="($event.target.type=\'datetime-local\')" (focusout)="($event.target.type=\'datetime-local\')" name="'+data.genericField.name+'"/>';
            }else{
                //output += '<input title="'+data.label+'" [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'" data-date-format="MM/DD/YYYY" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="'+((data.is_read_only) && (context) ? 'text' : 'date')+'" name="'+data.genericField.name+'"/></div>';
                output += '<input title="'+data.label+'"  [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'" data-date-format="MM/DD/YYYY" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="'+((data.is_read_only) && (context) ? 'datetime-local' : 'datetime-local')+'" (click)="($event.target.type=\'datetime-local\')" (focusout)="($event.target.type=\'datetime-local\')" name="'+data.genericField.name+'"/>';
            }
            output += labelHtml;
            output += '</div>';
            break;
        case Datatype.BOOLEAN:
            if(data.is_read_only){
                fieldClass = "floating-input";
            }else{
                fieldClass = "floating-input";
            }
            output += '<div class="smart-controls autocwidth format-menu form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';

            //output += '<div class="">';
            if(data.isDropdown){
                output += '<select (click)="$event.target.setAttribute(\'value\', $event.target.value);" title="'+data.label+'"  [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" name="'+data.genericField.name+'"><option value=""></option>';
                if(data.repeatedList){
                    for(var i = 0;i<data.repeatedList.length;i++){
                        output += '<option value="'+data.repeatedList[i].option_value+'">'+data.repeatedList[i].option_label+'</option>';
                    }
                }
                output += '</select>';
            }else if(data.isCheckBox){
                output += '<div class="'+inlineCss+'">';
                if(data.textAlign == 'text-right'){
                    output += '<label><input title="'+data.label+'" [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'" type="checkbox" value="true" name="'+data.genericField.name+'"/>&nbsp;'+data.label+'</label>';
                }else{
                    output += '<label>'+data.label+'&nbsp;<input title="'+data.label+'" [attr.readonly]="'+((data.is_read_only) ? true : null)+'" type="checkbox" value="true" name="'+data.genericField.name+'"/></label>';
                }
                output += '</div>';
            }
            else{
                // for(var i = 0;i<data.repeatedList.length;i++){
                //     if(data.textAlign == 'text-right'){
                //         output += '<div class="radio-options '+inlineCss+'">';
                //         output += '<input type="radio" value="'+data.repeatedList[i].option_value+'" name="'+data.genericField.name+'"/>&nbsp;';
                //         output += '<label>'+data.repeatedList[i].option_label+'</label></div>';
                //     }else{
                //         output += '<div class="radio-options '+inlineCss+'">';
                //         output += '<label>'+data.repeatedList[i].option_label+'</label>&nbsp;';
                //         output += '<input type="radio" value="'+data.repeatedList[i].option_value+'" name="'+data.genericField.name+'"/></div>';
                //     }
                // }
                output += '<select (click)="$event.target.setAttribute(\'value\',$event.target.value);" title="'+data.label+'" [attr.readonly]="'+((data.is_read_only) && (context) ? true : null)+'" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" name="'+data.genericField.name+'"><option value=""></option>';
                if(data.repeatedList){
                    for(var i = 0;i<data.repeatedList.length;i++){
                        output += '<option value="'+data.repeatedList[i].option_value+'">'+data.repeatedList[i].option_label+'</option>';
                    }
                }
                output += '</select>';
            }
            //output += '</div>';
            output += labelHtml;
            output += '</div>';
            break;
        default:
            output += '<div class="smart-controls form-group" data-elementid="'+data.id+'"><label>'+data.label+'</label></div>';
    }
    return output;
}
//Generating html by standard smart UI Controls
getUIHTML(data,context:Context){

    var output = "";
    //console.log("Get ui Data",data);
    //var requiredClass = "{'required':"+((data.is_required) ? true : false)+"}";
    let requiredClass = [];
    (data.is_required) ? requiredClass.push('required ') : '';
    var isImageEmpty = (data.imageUrl == undefined || data.imageUrl == '') ? true : false;
    var css = ['floating-label'];;
    var inlineCss = [];
    var style = [];
    var fieldwidth = [];
    let labelHtml = '';
    let labelClass = '';
    let fieldClass = '';
    (data.bold == "Yes") ? css.push('font-weight-bold') : '';
    (data.fontStyle == "italic") ? css.push('italic') : (data.fontStyle == "underline") ? css.push('underline') : (data.fontStyle == "italic_underline") ? css.push('italic_underline') : '';
    (data.cssClass) ? css.push(data.cssClass) : '';
    //(data.inline) ? inlineCss.push('form-inline') : '';
    (data.fontColor) ? style.push("color:"+data.fontColor+";") : '';
    (data.fieldWidth) ? fieldwidth.push("width:"+data.fieldWidth+"%;") : '';
    if(data.elementType != ElementType.HEADING){
         (data.fontSize) ? style.push("font-size:"+data.fontSize+"px;") : '';
    }
    if(data.elementType == ElementType.IMAGE){
        if(data.textAlign == "text-center"){
             css.push("image-center");
        }else if(data.textAlign == "text-right"){
             css.push("float-right");
        }
    }else{
         //css.push(data.textAlign);
    }
    if(data.inline){
        inlineCss.push('form-inline');
        labelClass = 'col-md-3ss';
        if(data.isTextHide){
            fieldClass = 'col-md-12 floating-input';
        }else{
            fieldClass = 'col-md-9ss floating-input';
        }
    }else{
        labelClass = '';
        fieldClass = 'floating-input';
        //inlineCss.push('')
    }
    if(data.isTextHide == false){
        if(data.is_required){
            labelHtml = '<span class="highlight"></span><label for="'+data.id+'" style="'+style.join("")+'" class="required '+data.textAlign+' '+labelClass+'">'+data.label+'<span>*</span></label>';
        }else{
            labelHtml = '<span class="highlight"></span><label for="'+data.id+'" style="'+style.join("")+'" class="'+data.textAlign+' '+labelClass+'">'+data.label+'</label>';
        }
    }else{
        labelHtml = '';
    }
   // console.log('calling uihtml',data);
    switch(data.elementType)
    {
        case ElementType.HEADING:
            output += '<div class="smart-controls smart-heading form-group '+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            output += '<'+data.heading_level+' [hidden]="'+data.isTextHide+'" style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" id="'+data.id+'">'+data.label+'</'+data.heading_level+'>';
            output += '</div>';
            break;
        case ElementType.PARAGRAPH:
            output += '<div class="smart-controls form-group '+inlineCss+' '+data.textAlign+' '+css.join(" ")+'" data-elementid="'+data.id+'">';
            output += '<p [hidden]="'+data.isTextHide+'" style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" id="'+data.id+'">'+data.label.replace(/(?:\r\n|\r|\n)/g, '<br>');+'</p>';
            //output += data.label.replace(/(?:\r\n|\r|\n)/g, '<br>');
            output += '</div>';
            break;
        case ElementType.CHECKBOX:
            //this.checkEditable(data,css.join(" "));
             let role = JSON.parse(this.localStorageService.get('currentUser'));
            //// console.log(role.roles[0].authority.split(" ").join("-"));
            if(role?.roles[0]?.authority == 'Fort Wayne Admin'){                   
                output += '<div class="smart-controls checkbox-wrapper form-group '+requiredClass.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
                //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
                output += labelHtml;
                for(var i = 0;i<data.repeatedList.length;i++){
                    output += '<div class="checkbox-element list-options d-flex w-100 justify-content-end">';
                    if(data.textAlign == 'text-right'){
                        output += '<input [attr.readonly]="'+((data.is_read_only) ? true : null)+'" type="checkbox" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'" value="'+data.repeatedList[i].option_value+'"/>&nbsp;';
                        output += '<label>'+data.repeatedList[i].option_label+'</label>';
                    }else{
                        output += '<input [attr.readonly]="'+((data.is_read_only) ? true : null)+'" type="checkbox" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'" value="'+data.repeatedList[i].option_value+'"/>&nbsp;';
                        output += '<label>'+data.repeatedList[i].option_label+'</label>';

                    }
                    output += '</div>';
                }
                output += '</div>';
            }
            break;
        case ElementType.RADIO:
            output += '<div class="smart-controls format-radio form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
            output += labelHtml;
            output += '<div class="form-group">';
            for(var i = 0;i<data.repeatedList.length;i++){
                output += '<label>'+data.repeatedList[i].option_label+'</label><input type="radio" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'"/>';
            }
            output += '</div>';
            output += '</div>';
            break;
        case ElementType.PASSWORD:
            output += '<div style="'+fieldwidth.join("")+'" class="smart-controls form-group '+requiredClass.join(" ")+css.join(" ")+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
            output += labelHtml;
            output += '<input class="form-control" type="password" id="'+data.id+'" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'"/>';
            output += '</div>';
            break;
        case ElementType.TEXTBOX:
            //// console.log(css.join(" "));
            // let role = JSON.parse(this.localStorageService.get('currentUser'));
            //// console.log(role.roles[0].authority.split(" ").join("-"));
            // let role_editable = role?.roles[0]?.authority?.split(" ")?.join("") + '_editable';
            // if(role_editable){
            //     let editableText = this.findTextInSentence(css.join(" "),role_editable);
            //    // console.log(role_editable,editableText);
            //     if(editableText) data.is_read_only = false;
            // }  
            this.checkEditable(data,css.join(" "));         
            output += '<div style="'+fieldwidth.join("")+'" class="smart-controls form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';

            if(data.name){
                output += '<input  [attr.readonly]="'+((data.is_read_only) ? true : null)+'" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="text" id="'+data.id+'" name="'+data.name+'"/>';
            }else{
                output += '<input  [attr.readonly]="'+((data.is_read_only) ? true : null)+'" style="'+fieldwidth.join("")+'" class="form-control '+fieldClass+'" type="text" id="'+data.id+'" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'"/>';
            }
            output += labelHtml;
            output += '</div>';
            break;
        case ElementType.LIST_ITEM:
            output += '<div class="smart-controls form-group '+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [hidden]="'+data.isTextHide+'">'+data.label+'</label>';
            output += labelHtml;
            output += '<ul id="'+data.id+'">';
            for(var i = 0;i<data.listItems.length;i++){
                if(data.listItems[i].url)
                    output += '<li><a target="_blank" href="'+window.location.protocol+'//'+data.listItems[i].url+'">'+data.listItems[i].list_items+'</a></li>';
                else
                    output += '<li>'+data.listItems[i].list_items+'</li>';
            }
            output += '</ul>';
            output += '</div>';
            break;
        case ElementType.DROPDOWN:
           // console.log('readonly',data);
            // if(role_editable){
            //     let editableText = this.findTextInSentence(css.join(" "),role_editable);
            //    // console.log(role_editable,editableText);
            //     if(editableText) data.is_read_only = false;
            // } 
            this.checkEditable(data,css.join(" "));
            output += '<div class="smart-controls form-group floating-label '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
            output += '<select [attr.readonly]="'+((data.is_read_only) ? true : null)+'" style="'+fieldwidth.join("")+'" class="form-control floating-input drop" id="'+data.id+'" name="'+data.defaultValue+'">';
            output += '<option value=""></option>';
            for(var i = 0;i<data.repeatedList.length;i++){
                output += '<option value="'+data.repeatedList[i].option_value+'">'+data.repeatedList[i].option_label+'</option>';
            }
            output += '</select>';
            output += labelHtml;
            output += '</div>';
            break;
        case ElementType.RADIO_QUESTION:
            output += '<div class="smart-controls format-radio  form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
            output += labelHtml;
            output += '<div class="form-group">';
            for(var i = 0;i<data.repeatedList.length;i++){
                output += '<div class="radio-options '+inlineCss+'"><input type="radio" value="'+data.repeatedList[i].option_value+'" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'"/><label>'+data.repeatedList[i].option_label+'</label></div>';
            }
            output += '</div>';
            output += '</div>';
            break;
        case ElementType.MENU_QUESTION:
            output += '<div class="smart-controls form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
            output += labelHtml;
            output += '<select style="'+fieldwidth.join("")+'" class="form-control" id="'+data.id+'" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'">';
            output += '<option value="">Select '+data.label+'</option>';
            for(var i = 0;i<data.repeatedList.length;i++){
                output += '<option value="'+data.repeatedList[i].option_value+'">'+data.repeatedList[i].option_label+'</option>';
            }
            output += '</select>';
            output += '</div>';
            break;
        case ElementType.LIST_QUESTION:
            output += '<div class="smart-controls checkbox-wrapper form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
            output += labelHtml;
            for(var i = 0;i<data.repeatedList.length;i++){
                output += '<div class="checkbox-element list-options">';
                if(data.textAlign == 'text-right'){
                    output += '<input type="checkbox" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'"/>&nbsp;';
                    output += '<label>'+data.repeatedList[i].option_label+'</label>';
                }else{
                    output += '<label>'+data.repeatedList[i].option_label+'</label>';
                    output += '<input type="checkbox" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'"/>&nbsp;';
                }
                output += '</div>';
            }
            output += '</div>';
            break;
        case ElementType.TEXT_QUESTION:
            output += '<div class="smart-controls form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
            output += labelHtml;
            output += '<input style="'+fieldwidth.join("")+'" class="form-control" type="text" id="'+data.id+'" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'"/>';
            output += '</div>';
            break;
        case ElementType.YES_NO_QUESTION:
            output += '<div class="smart-controls form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" id="'+data.id+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
            output += labelHtml;
            output += '<div class="form-group">';
            for(var i = 0;i<data.repeatedList.length;i++){
                output += '<div class="radio-options '+inlineCss+'"><input type="radio" value="'+data.repeatedList[i].option_value+'" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'"/><label>'+data.repeatedList[i].option_label+'</label></div>';
            }
            output += '</div>';
            output += '</div>';
            break;
        case ElementType.BUTTON:
            output += '<div class="smart-controls form-group '+data.textAlign+' '+css.join(" ")+'" data-elementid="'+data.id+'">';
            //output += '<button style="'+fieldwidth.join("")+'" style="'+style.join("")+'" class="btn btn-success '+css.join(" ")+'" type="button" id="'+data.id+'">'+data.label+'</button>';
            output += '<button (click)="buttonAction($event,\''+data.buttonAction+'\')"  style="'+fieldwidth.join("")+'" class="btn btn-success '+css.join(" ")+'" type="button" id="'+data.id+'">'+data.label+'</button>';
            output += '</div>';
            break;
        case ElementType.IMAGE:
            output += '<div class="smart-controls form-group" data-elementid="' + data.id + '">';
            if(!isImageEmpty){
                output += '<img style="'+fieldwidth.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" id="' + data.id + '" src="' + data.imageUrl + '" title="' + data.label + '"/>';
            }
            output += '</div>';
            break;
        case ElementType.FILEUPLOAD:
            output += '<div class="smart-controls form-group '+requiredClass.join(" ")+css.join(" ")+' '+inlineCss+'" data-elementid="'+data.id+'">';
            //output += '<label style="'+style.join("")+'" class="'+data.textAlign+' '+css.join(" ")+'" [ngClass]="'+requiredClass+'" [hidden]="'+data.isTextHide+'">'+data.label+'<span *ngIf="'+data.is_required+'">*</span></label>';
            output += labelHtml;
            output += '<input style="'+fieldwidth.join("")+'" class="form-controls file-upload" type="file" id="'+data.id+'" name="'+data.label.replace(/[^A-Z0-9]+/ig, "")+'"/>';
            output += '</div>';
            break;
        case ElementType.TAB_ACCORDION:
            //console.log(data);
            output += '<div class="smart-controls form-group" data-elementid="'+data.id+'">';
            //output += '<app-tab-view (loadcomplete)="loadCompleted($event)" [tabData]=\''+JSON.stringify(data)+'\'></app-tab-view>';
            output += '<app-tab-view (loadcomplete)="loadCompleted($event)" (componentSelection)="componentSelectionEmitter($event)" [context]=\''+JSON.stringify(context)+'\' [tabData]=\''+JSON.stringify(data)+'\'></app-tab-view>';
            output += '</div>';
            break;
        case ElementType.REPORT:

            output += '<div class="smart-controls form-group" data-elementid="'+data.id+'">';
            if(data.repeatedList.length>0){
                output += '<app-report-view (componentSelection)="componentSelectionEmitter($event)" [context]=\''+JSON.stringify(context)+'\' [reportId]="'+data.repeatedList[0].id+'"></app-report-view>';
            }
            output += '</div>';

            break;
        case ElementType.QUERYBUILDER:
           // console.log('query builder called',data);
            output += '<div class="smart-controls form-group" data-elementid="' + data.id + '">';
            if (data.querybuilderid) {
                //console.log(data)
                const componentContext = { id: data.querybuilderid,type:data.querybuildertype, name: data.label, randomid: this.randomId() };
                output += '<app-query-builder-processor [entitydata]=\'' + JSON.stringify(context) + '\' [componentContext]=\'' + JSON.stringify(componentContext) + '\' (componentSelection)="componentSelectionEmitter($event)"></app-query-builder-processor>';
            }
            output += '</div>';

            break;
        case ElementType.TRACKING:
                output += '<div class="smart-controls form-group" data-elementid="'+data.id+'">';
                output += '<app-tracking-view (componentSelection)="componentSelectionEmitter($event)" [context]=\''+JSON.stringify(context)+'\'></app-tracking-view>';
                output += '</div>';
            break;
        case ElementType.BABYSTATUSCONDITIONS:
                output += '<div class="smart-controls form-group" data-elementid="'+data.id+'">';
                output += '<app-baby-status-conditions (componentSelection)="componentSelectionEmitter($event)" [context]=\''+JSON.stringify(context)+'\'></app-baby-status-conditions>';
                output += '</div>';
            break;
        case ElementType.RENDER:
                output += '<div class="smart-controls form-group smart-render" data-elementid="'+data.id+'">';
                output += '<label>'+data.label+'</label>';
                output += '</div>';
            break;
        case ElementType.GRAPH:
            output += '<div class="smart-controls form-group smart-render" data-elementid="'+data.id+'">';
            output += '<label>'+data.label+'</label>';
            output += '</div>';
            break;
        case ElementType.CARD:
            output += '<div class="smart-controls form-group smart-render" data-elementid="'+data.id+'">';
            output += '<app-card-view (componentSelection)="componentSelectionEmitter($event)" [componentContext]=\''+JSON.stringify(data)+'\' [context]=\''+JSON.stringify(context)+'\'></app-card-view>';
            output += '</div>';
            break;
        case ElementType.ATTACHMENTS:
            output += '<div class="smart-controls form-group" data-elementid="'+data.id+'">';
            output += '<app-attachments-view (componentSelection)="componentSelectionEmitter($event)" [context]=\''+JSON.stringify(context)+'\'></app-attachments-view>';
            output += '</div>';
            break;
        default:
            if(data.id != -1){
                output += '<div class="smart-controls form-group" data-elementid="'+data.id+'">';
                output += '<label>'+data.label+'</label>';
                output += '</div>';
            }
    }
    return output;
}
   getCurrentDate(){
        let dd :any,mm:any,yyyy:any,today:any;
        today = new Date();
        dd = today.getDate();mm = today.getMonth()+1; yyyy = today.getFullYear();
        if(dd<10) {dd='0'+dd;}
        if(mm<10) {mm='0'+mm;}
        today = mm+'/'+dd+'/'+yyyy;
        return today;
    }
    serializeObject(form:any){
        let o = {};
        let a = form.serializeArray();
        jq.each(a, function() {
            if(this.value){
                if (o[this.name] && this.value) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            }
        });
        return o;
    }
    convertToEST(data){

        //EST
        //let offset = -4.00;

        let clientDate = new Date(data);

        //let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000);

        //let serverDate = new Date(utc + (3600000*offset));

        return clientDate.toLocaleString('en-US', { hour12: true });

    }
    getDate(data){
        if(data){
            let dd :any,mm:any,yyyy:any,d:any;
            d = new Date(data);
            dd = d.getDate();mm = d.getMonth()+1; yyyy = d.getFullYear();
            if(dd<10) {dd='0'+dd;}
            if(mm<10) {mm='0'+mm;}
            d = mm+'/'+dd+'/'+yyyy;
            return d;
        }else{
            return '';
        }
    }
    getDateByFormat(data,symbol,format){
        if(data){
            let dd :any,mm:any,yyyy:any,d:any;
            d = new Date(data);
            dd = d.getDate();mm = d.getMonth()+1; yyyy = d.getFullYear();
            if(dd<10) {dd='0'+dd;}
            if(mm<10) {mm='0'+mm;}
            if(format == 'ymd'){
                d = yyyy+symbol+mm+symbol+dd;
            }
            if(format == 'mdy'){
                d = mm+symbol+dd+symbol+yyyy;
            }
            if(format == 'dmy'){
                d = dd+symbol+mm+symbol+yyyy;
            }
            return d;
        }else{
            return '';
        }
    }
    convertDates(data){
        if(data){
          if(data.length >10)
          {data = data.substring(0, data.length - 1);}
         // console.log(data);
          return data.replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3-$1-$2");
        }
      }
    getTimeStampDate(data){
        if(data){
            let d:any;
            d = new Date(data+" 00:00:00").getTime();
            return d;
        }else{
            return '';
        }
    }
    getTimeStampDateTime(data){
        if(data){
            let d:any;
            d = new Date(data).getTime();
            return d;
        }else{
            return '';
        }
    }
    setDate(data){
        // console.log('set date',data);
        // let dd :any,mm:any,yyyy:any,d:any;
        // d = new Date(data);
        // dd = d.getDate();mm = d.getMonth()+1; yyyy = d.getFullYear();
        // if(dd<10) {dd='0'+dd;}
        // if(mm<10) {mm='0'+mm;}
        // d = yyyy+'-'+mm+'-'+dd;
        // return d;
        return moment(data).utc().format("YYYY-MM-DD");
    }
    getDateTime(data){
       // var date = new Date(data).toUTCString();
        return moment(data).format("YYYY-MM-DD[T]HH:mm:ss");
    }
    setObjectData(data:any){
        this.objectData = data;
    }
    getObjectData(){
        return this.objectData;
    }
    setObjectMetaData(data:any){
        this.objectMetaData = data;
    }
    getObjectMetaData(){
        return this.objectMetaData;
    }
    convertArrayForPicklist(data){
        let tempArray = [];
        for(let pli in data){
          tempArray.push(data[pli].id);
        }
        return tempArray;
    }
    convertArrayForPicklistToName(data){
        let tempArray = [];
        for(let pli in data){
          tempArray.push(data[pli].valueen);
        }
        return tempArray;
    }
    SortByName(x,y) {
        return ((x.option_label == y.option_label) ? 0 : ((x.option_label > y.option_label) ? 1 : -1 ));
    }
    SortByID(x,y) {
        return x.id - y.id;
    }
    SortByValue(x,y) {
        return x.option_value - y.option_value;
    }
    getPicklistByEnity(name:string){
        var payload = {"entityName": name};
        return this.httpClient.post(this.backendUrl+ 'gquery',payload, httpOptions);
        // return this.httpClient.get(this.backendUrl + 'getPickListValuesByID/' + id, {
        //     headers: this.httpHeaders
        // }).pipe(retry(2), catchError(this.handleError));
    }
    getPicklistByID(id:number){
        return this.httpClient.get(this.backendUrl+'cache/getPickListValuesByID/'+id, httpOptions).pipe(retry(2), catchError(this.handleError));
    }
    getAllTodaysServiceRequest(){
        return this.httpClient.get(this.backendUrl+'getAllTodaysServiceRequest', {
            headers: this.httpHeaders
        }).pipe(retry(2), catchError(this.handleError));
    }
    getTop5Casetypes(){
        return this.httpClient.get(this.backendUrl+'getTop5Casetypes', {
            headers: this.httpHeaders
        }).pipe(retry(2), catchError(this.handleError));
    }
    emitData(data) {
        this.change.emit(data);
    }

    private handleError(errorObj: HttpErrorResponse | any) {
        const _self = this;
        let errorMessage: string;
        let body: any;
        if (errorObj instanceof HttpErrorResponse) {
            if (errorObj.ok === false && errorObj.status === 0) {
                errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime.';
            } else {
                body = errorObj.error || '';
                errorMessage = body.message ? body.message : body.error.message;
            }
        }
        return throwError(errorMessage);
    }
    setIncidentEmailOrNote(val) {
        this.incident.next(val);
    }
    setUserDetails(val){
        this.userDetails.next(val);
    }

    SavetolocalStorage(key: any, item: any): void {
        // Fetch the payload from localStorage and parse it to an array
        let localstoragepayload: any = JSON.parse(localStorage.getItem(key) || '[]');
       // console.log(localstoragepayload);

        // Find the index of the item with the given name
        let itemIndex = localstoragepayload?.findIndex((obj: any) => obj.name == item?.name);

        if (localstoragepayload == null) {
            // Initialize the array and push the new item
            localstoragepayload = [item];
        } else if (itemIndex != -1) {
            // Remove the existing item and push the new item
            localstoragepayload.splice(itemIndex, 1);
            localstoragepayload.push(item);
        } else {
            // Push the new item if it's not already in the array
            localstoragepayload.push(item);
        }

        // Update localStorage with the modified array
        localStorage.setItem(key, JSON.stringify(localstoragepayload));
    }

    fetchfromlocalStorage(key:any)
    {
        if(localStorage.getItem(key) && localStorage.getItem(key)!=null)
            {
                return localStorage.getItem(key)
            }
            return null
    }

    clearlocalStorage(key:any,referrenceid:any)
    {
        var localstoragepayload:any=JSON.parse(localStorage.getItem(key) || '[]');
        // alert(!Array.isArray(localstoragepayload))
       // console.log(localstoragepayload)
       // console.log(!Array.isArray(localstoragepayload))
        if(Array.isArray(localstoragepayload))
            {
               // console.log(localstoragepayload,referrenceid)
                if(key=='tabdata')
                {
                    // alert()
                    let itemIndex = localstoragepayload[0]?.findIndex((item: any) => item.refno === referrenceid)
                    if(itemIndex == -1 || undefined)
                        {
                           // console.log("no data found")
                            return 0
                        }
                        else
                        {
                            localstoragepayload[0]?.splice(itemIndex, 1);
                            localStorage.removeItem(key)
                            localStorage.setItem(key, JSON.stringify(localstoragepayload));
                        }
                }
                else
                {
                    let itemIndex = localstoragepayload?.findIndex((item: any) => item.name === referrenceid)
                if(itemIndex == -1 || undefined)
                    {
                       // console.log("no data found")
                        return 0
                    }
                    else
                    {
                        localstoragepayload.splice(itemIndex, 1);
                        localStorage.setItem(key, JSON.stringify(localstoragepayload));
                    }
                }
                
            }


    }

    getImageUrl(attachmentname:any)
    {
        //// console.log(attachmentname)

        return attachmentname.includes('.png')
      ?  'bi bi-filetype-png'
      : attachmentname.includes('.pdf') 
      ? 'fa-solid fa-file-pdf text-danger'
      : attachmentname.includes('.csv') 
      ? 'fa-solid fa-file-csv text-success'
      : attachmentname.includes('.xlsx') 
      ? 'fa-regular fa-file-excel text-success'
      : attachmentname.includes('.mp4') 
      ? 'fa-regular fa-file-video text-danger'
      : attachmentname.includes('.doc') 
      ? 'fa-solid fa-file-word text-primary'
      : attachmentname.includes('.svg') 
      ? 'bi bi-filetype-svg text-info'
      : attachmentname.includes('.jpeg') 
      ? 'fa-solid fa-image'
      : 'fa-solid fa-image'; // default icon

       
    }
    saveFavorite(payload:any)
    {        
        return this.httpClient.post(this.backendUrl+ 'saveAgentFavSR',payload);
    }
    setDefaultData;
    setDefaultFilterData(data:any){
        this.setDefaultData = data;
    }
    getDefaultFilterData(){
        return this.setDefaultData;
    }
    setReadOnlyData;
    setReadOnlyInput(data:any){
        this.setReadOnlyData = data;
    }
    getReadOnlyInput(){
        return this.setReadOnlyData;
    }
    ///////////////////// find text    
    findTextInSentence(sentence, searchText) {
       // console.log(sentence,searchText);
        let escapedWord = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        
        // Create a regular expression to match the exact word including hyphens and underscores
        let regex = new RegExp(`(?<!\\w)${escapedWord}(?!\\w)`, 'i');
        
        // Test if the word exists in the sentence
        return regex.test(sentence);
    }
    //////////////// find text    
    checkEditable(data,css){  
        //// console.log(css.join(" "));
        let role = JSON.parse(this.localStorageService.get('currentUser'));
       // console.log(role.roles[0].authority.split(" ").join("-"));
        let role_editable = role?.roles[0]?.authority?.split(" ")?.join("") + '_editable';
        if(role_editable){
            let editableText = this.findTextInSentence(css,role_editable);                   
            if(editableText) data.is_read_only = false;
        }        
    }
}
